import PropTypes from 'prop-types';
import React from 'react';

const INTERCOM_APP_ID = 'rmvdg6n1';

const _runIntercomScript = () => {
  (function() {
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', window.intercomSettings);
    } else {
      const d = document;
      var i = function() {
        i.c(arguments);
      };
      i.q = [];
      i.c = function(args) {
        i.q.push(args);
      };
      w.Intercom = i;
      function l() {
        const s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://widget.intercom.io/widget/' + INTERCOM_APP_ID;
        const x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      }
      if (document.readyState == 'complete') {
        l();
      }
      if (w.attachEvent) {
        w.attachEvent('onload', l);
      } else {
        w.addEventListener('load', l, false);
      }
    }
  })();
};

_runIntercomScript();

// let intercomBoot = false;

export default class IntercomInit extends React.Component {
  static contextTypes = {
    getCurrentUserInfo: PropTypes.func
  };

  constructor(props, context) {
    super(props, context);
    this.intercomInit(props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.intercomInit(nextProps);
  }

  intercomInit = props => {
    if (!props.loggedOutUser) {
      const user = this.context.getCurrentUserInfo();
      // const companyName = user.company_name;

      if (window.top === window.self && user) {
        // !window.Intercom && this._runIntercomScript();
        // window._intercomInit1 = true;
        // window.Intercom('shutdown');
        setTimeout(() => {
          window.Intercom('update', {
            app_id: INTERCOM_APP_ID,
            name: user.name,
            user_id: user.pid,
            email: user.email,
            companies: {
              company_id: user.companyId,
              name: user.company_name
            },
            created_at: new Date().getTime()
          });
        }, 800);
        // intercomBoot = true;
      }
    } else if (window.top === window.self) {
        // !window.Intercom && this._runIntercomScript();
        // window._intercomInit2 = true;
        setTimeout(() => {
          window.Intercom('shutdown');
          setTimeout(() => {
            window.Intercom('boot', {
              app_id: INTERCOM_APP_ID
            });
          }, 800);
        }, 800);
        // intercomBoot = true;
      }
  };

  render() {
    return null;
  }
}

IntercomInit.defaultProps = {
  loggedOutUser: false
};
